import { createAction } from "../../utils";
import { MODAL_OPEN } from "../../constants";

const modalOpen = createAction(MODAL_OPEN);

export const openModal =
  (modalName, { data }) =>
  (dispatch) => {
    dispatch(
      modalOpen({
        modalName,
        data,
      }),
    );
  };
